import { PATHS } from 'routes/routes.constants';

export function getOtEnv() {
  return {
    domain:
      process.env.NEXT_PUBLIC_AUTH0_STUDIO_DOMAIN ||
      process.env.NEXT_PUBLIC_AUTH0_DOMAIN,
    audience: process.env.NEXT_PUBLIC_AUTH0_AUDIENCE,
    scope:
      process.env.NEXT_PUBLIC_OT_AUTH0_SCOPE ??
      'openid profile email offline_access',
  };
}

export function getCallbackUrl(pathname = PATHS.OPENTABLE_CALLBACK) {
  return `${window.location.origin}${pathname}`;
}
